import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AnalyticsModule } from './analytics/analytics.module';
import { AnalyticsService } from './analytics/analytics.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { GlobalErrorHandler } from './core/error-handling/global-error-handler';
import { HomeComponent } from './home/home.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AboutComponent } from './about/about.component';
import { RoomDirectoryComponent } from './room-directory/room-directory.component';
import { AdminEventComponent } from './admin-event/admin-event.component';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { AdminEventDetailComponent } from './admin-event-detail/admin-event-detail.component';
import { NgbDatepickerModule, NgbTimepickerModule, NgbPopover, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService,MsalInterceptor,MsalInterceptorConfiguration,MsalRedirectComponent,MsalService } from '@azure/msal-angular';
import { TodayEventsComponent } from './today-events/today-events.component';
import { EventsAndHearingsComponent } from './events-and-hearings/events-and-hearings.component';
import { DirectionsComponent } from './directions/directions.component';
import { AdminEventImportsComponent } from './admin-event-imports/admin-event-imports.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

function MsalInstanceFactory(): IPublicClientApplication { //for admin event management page only
  return new PublicClientApplication({
    auth: {
      clientId: '65eb4c83-e8a0-43ea-825c-4bc6f2cb8776',
      authority: 'https://login.microsoftonline.com/0b947e6b-ff26-4b13-ae1c-573c6750c888',
      redirectUri: '/admin-events',
    }
  });
}

//function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
//  const protectedResourceMap = new Map<string, Array<string> | null>([
//    ['https://graph.microsoft.com/v1.0/me', ['user.read']],
//    ['/api/Admin/*', ['api://65eb4c83-e8a0-43ea-825c-4bc6f2cb8776/api']]
//  ])

//  return {
//    interactionType: InteractionType.Redirect,
//    protectedResourceMap,
//  };
//}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    RoomDirectoryComponent,
    AdminEventComponent,
    AdminEventDetailComponent,
    AdminEventImportsComponent,
    TodayEventsComponent,
    EventsAndHearingsComponent,
    DirectionsComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FontAwesomeModule,
    AgGridAngular,
    AgGridModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbPopoverModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      maxOpened: 1,
      autoDismiss: true,
      preventDuplicates: true,
      positionClass: 'toast-bottom-right'
    }),
    AnalyticsModule.forRoot(environment.GA_MEASUREMENT_ID)
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MsalInstanceFactory
    },
    MsalService,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {
  constructor(private analyticsService: AnalyticsService) {
    if (environment.ENABLE_ANALYTICS) {
      this.analyticsService.trackPageViews();
    }
  }
}
